<template>
    <div class="warpper">
        <div class="bg-white">
            <div class="flex align-center">
                <div class="page-title">基本信息</div>
                <div class="status">（{{ detail.examine_status | status }}）</div>
            </div>
            <div v-if="detail.examine_status === 3" class="reason margin-top">
                拒绝原因：{{ detail.examine_msg }}
            </div>
            <el-form ref="ruleForm" :model="ruleForm" class="info margin-top" labelWidth="auto" label-position="top">
                <el-row :gutter="20">
                    <el-col v-for="(item,index) in ruleForm.list"
                            :key="index" :span="(item.type === 2 || item.type ===6|| item.type ===7) ? 24 : 12">
                        <el-form-item v-if="item.type === 1 && (item.isShow === undefined || item.isShow)" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-input v-model="item.answer" :disabled="readonly"
                                      :placeholder="item.placeholder || '请输入' + item.title"></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.type === 2 && (item.isShow === undefined || item.isShow)" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-input v-model="item.answer" :disabled="readonly"
                                      :placeholder="'请输入' + item.title" type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.type === 3 && (item.isShow === undefined || item.isShow)  && !item.hide" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-select v-model="item.answer" :disabled="readonly || item.disabled" :placeholder="'请选择' + item.title"
                                       class="w-all" clearable>
                                <el-option v-for="option in item.options" :key="option.value"
                                           :label="option.label"
                                           :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.type === 4 && (item.isShow === undefined || item.isShow)" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-select v-model="item.answer" :disabled="readonly" :placeholder="'请选择' + item.title"
                                       class="w-all" clearable multiple>
                                <el-option v-for="option in item.options" :key="option.value"
                                           :label="option.label"
                                           :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.type === 5 && (item.isShow === undefined || item.isShow)" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-cascader
                                v-model="item.answer"
                                :disabled="readonly"
                                :options="options"
                                expand-trigger="hover"
                                filterable
                                placeholder="请选择单位所在地"
                                style="width: 100%;">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item v-if="item.type === 6 && (item.isShow === undefined || item.isShow)" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <infoUpFile :disabled="readonly" :file="item.answer" :index="index" :limit="item.limit"
                                        :type="item.type"
                                        @saveFile="saveFile"/>
                        </el-form-item>
                        <el-form-item v-if="item.type === 7 && (item.isShow === undefined || item.isShow)" :ref="'list' + index +'answer'"
                                      :label="item.title"
                                      :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <infoUpFile :disabled="readonly" :file="item.answer" :index="index" :limit="item.limit"
                                        :type="item.type"
                                        @saveFile="saveFile"/>
                        </el-form-item>
                      <el-form-item v-if="item.type === 8 && (item.isShow === undefined || item.isShow)"  :ref="'list' + index +'answer'"
                                    :label="item.title"
                                    :prop="'list.' + index + '.answer'"
                                    :rules="item.rules">
                        <el-date-picker
                          v-model="item.answer"
                          :disabled="readonly"
                          placeholder="请选择日期"
                          style="width: 100%"
                          value-format="yyyy-MM-dd"
                          type="date">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                </el-row>
                <div class="flex align-center justify-center margin-tb">
                    <el-button v-if="detail.examine_status !== 2" :loading="loading" class="input-form-btn"
                               type="primary" @click="submitForm('ruleForm')">{{ readonly ? '编辑' : '提交' }}
                    </el-button>
                </div>
            </el-form>
            <div class="info-container margin-bottom-sm flex-sub">
                <div class="flex align-start justify-between margin-bottom-sm">
                    <div class="page-title">积分信息</div>
                </div>
                <div class="ship-list flex flex-direction align-center">
                    <el-table
                        :data="integrals"
                        border
                        header-row-class-name="table-header"
                        style="width: 100%;border-radius: 10px">
                        <el-table-column label="序号" prop="name">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ (page - 1) * limit + scope.$index + 1 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="积分" prop="integral">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.integral }}分
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="获取时间" prop="create_time">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.create_time }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="获取途径" prop="integral_type_name">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.integral_type_name }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        :current-page.sync="page"
                        :page-size="limit"
                        :total="integral_tatal"
                        background
                        class="page-all margin-top"
                        layout="prev, pager, next, jumper"
                        @current-change="getIntegralDetail">
                    </el-pagination>
                </div>
            </div>
        </div>

        <div v-if="kefu" class="bg-white margin-top-sm">
            <div class="flex align-center justify-between">
                <div class="page-title">专属客服</div>
                <el-button class="yellow-btn" round>
                    {{ kefu }}：{{ kefuTel }}
                </el-button>
            </div>
        </div>


    </div>
</template>

<script>
import {regionData} from "element-china-area-data";
import {getInformation, getRankList, setInfo, userInfo,getOrganizInfo} from '@/api/member'
import infoUpFile from "@/components/InfoUpFile";
import {patternChange} from "../../../../utils/utils";
import {getIntegralDetail} from "../../../../api/member";

export default {
    name: "vipBasic",
    components: {infoUpFile},
    data() {
        return {
            readonly: true,
            detail: '',
            ruleForm: {
                list: [],
            },
            options: regionData,
            levelList: [],
            loading: false,

            kefu: '',
            kefuTel: '',

            integrals: [],
            integral_tatal: 0,
            page: 1,
            limit: 5
        }
    },
    created() {
        this.$emit('setIndex', 0, '基本信息')
        this.init()
        this.getIntegralDetail()
    },
    computed:{
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        //  获取表单
        async init() {
            let _data = await getInformation()
            if (_data.status === 200) this.ruleForm.list = JSON.parse(_data.data.user_more_json)
            this.getUserInfo()
        },
        async getIntegralDetail() {
            let _data = await getIntegralDetail(this.user.orgData.mid,this.user.mid,1,this.page,this.limit)
            this.integrals = _data.data
            this.integral_tatal = _data.count
        },
        async getUserInfo() {
            let _data = await userInfo()
            if (_data.status === 200) {
                await this.getLevel(_data.data.user_type)
                this.detail = _data.data
                this.kefu = _data.data.kefu_name
                this.kefuTel = _data.data.kefu_tel
                this.showDetail(JSON.parse(_data.data.user_more_json))
            }
        },
        showDetail(obj) {
            obj.map(item => {
                this.ruleForm.list.map(items => {
                    if (item.title === items.title  ||  (item.field || '')  === items.field || items.field === item.title) {
                        items.answer = item.answer
                    }
                })
            })
        },
        submitForm(formName) {
            if (this.readonly) return this.readonly = false
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitChange();
                } else {
                    let error = Object.values(validates).shift().shift()
                    let eles = this.$refs[error.field.split('.').join('')]
                    let dom = eles instanceof Array ? eles[0] : eles
                    dom.$el.scrollIntoView({
                        block: 'center', // 当前元素显示在视图区域中间
                        behavior: 'auto' // 滚动速度
                    })
                }
            });
        },
        async submitChange() {
            this.loading = true
            let _data = await setInfo(JSON.stringify(this.ruleForm.list))
            this.loading = false
            if (_data.status === 200) {
                this.readonly = true
                this.detail.examine_status = 2
                this.$confirm('提交成功，请等待机构审核', "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "warning",
                }).then(() => {
                })
            }
        },
        //  同步附件信息
        saveFile(val) {
            const _index = val[0]
            this.ruleForm.list[_index].answer = val[1]
            this.$set(this.ruleForm.list, _index, this.ruleForm.list[_index])

        },
        //  获取会员等级列表
        async getLevel(user_type) {
            let _data = await getRankList(user_type)
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.levelList = _data.data
            _data = await getOrganizInfo()
            this.ruleForm.list = patternChange(this.ruleForm.list,this.levelList,_data.data.morgname,[],_data.data.parent_id_fenhui)

        },
    },
    filters: {
        status(type) {
            switch (Number(type)) {
                case 2:
                    return "审核中";
                case 3:
                    return "审核不通过";
                default:
                    return "审核通过";
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {

    .status {
        font-size: 14px;
        color: #ffb400;
    }

    .reason {
        padding: 30px;
        background-color: #fff3da;
        border-radius: 6px;
        border: dashed 1px #ffe3ad;
        font-size: 16px;
        color: #ffb400;

    }

    .input-form-btn {
        width: 200px;
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;
        margin-top: 20px;
        padding: 0;

        &.white {
            background: #ffffff none;
            color: #ff9600;
        }

        &:disabled {
            background: #b4c7e5 none;
        }
    }
}
.table-name {
    font-size: 16px;
    color: #0a2240;
    text-align: center;
}
</style>
